import styled from 'styled-components';

import { JobTeaserCard } from '@xing-com/crate-jobs-xinglets';
import { Button, TextButton } from '@xing-com/crate-lebenslauf-button';
import { IllustrationEmptyStateSuitcase } from '@xing-com/illustrations';
import { mediaNavExtended } from '@xing-com/layout-tokens';
import { PopUpWindow } from '@xing-com/pop-up-window';
import { spaceXXS, spaceL, spaceXXL, xdlColorLink } from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

export const StyledScrollWrapper = styled.div`
  overflow-y: auto;
  padding: 0 3px;
  margin: ${spaceL} -3px 0 -3px;
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceL};

  & > * {
    width: 300px;
  }
`;

export const StyledJobTeaserCard = styled(JobTeaserCard)`
  width: 300px;
  height: auto !important;
`;

export const StyledJobsWindow = styled(PopUpWindow)<{ $isWide: boolean }>`
  & > * {
    width: 320px !important;
  }

  @media ${mediaNavExtended} {
    & > * {
      width: ${({ $isWide }) => ($isWide ? '1000px' : '670px')} !important;
    }
  }
`;

export const StyledButtonWrapper = styled.div`
  @media ${mediaNavExtended} {
    display: flex;
    justify-content: flex-end;
  }
`;

export const StyledContinueButton = styled(Button)`
  margin-top: ${spaceXXL};
  width: 100%;

  @media ${mediaNavExtended} {
    width: auto;
  }
`;

export const StyledAlertButton = styled(Button)`
  margin-top: ${spaceXXL};
  margin-right: ${spaceL};
  width: 100%;

  @media ${mediaNavExtended} {
    width: auto;
  }
`;

export const StyledMoreButton = styled(TextButton)`
  margin-left: ${spaceXXS};
  color: ${xdlColorLink};
  justify-content: flex-start;

  &:visited {
    color: ${xdlColorLink};
  }

  @media ${mediaNavExtended} {
    margin-top: 90px;
  }
`;

export const StyledHero = styled(Hero)`
  @media ${mediaNavExtended} {
    font-size: 42px;
  }
`;

export const StyledIllustration = styled(IllustrationEmptyStateSuitcase)`
  margin-bottom: ${spaceXXL};
`;

export const StyledEmptySearch = styled.div`
  text-align: center;
`;
